module.exports = __webpack_public_path__ + "static/hunger-be57405e41421e81294b6444a99fa64d.png";